export default __webpack_public_path__ + "static/media/04AW2JUL66.5cd5287a.jpg";